module.exports = __webpack_public_path__ + "static/home-artist-management-315bbcdc06503936d79278916e0b146a.webp";